import { useQuery } from "react-query"
import axios from "axios";
const useAllUserOrders = (userId) => {
    const headers = {
        token: localStorage.getItem("userToken"),
    };
    const getAllUserOrders = async () => {
        try {
            const response = await axios.get(`https://ecommerce.routemisr.com/api/v1/orders/user/${userId}`,
                {
                    headers
                })
            return response.data;
        } catch (error) {
            throw error.response.data.message
        }
    }
    return useQuery('allUserOrders', getAllUserOrders)
}

export default useAllUserOrders;